/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class DashboardControllerDtoGetDashboardDataDurationType.
* @enum {}
* @readonly
*/
export default class DashboardControllerDtoGetDashboardDataDurationType {
    
        /**
         * value: 0
         * @const
         */
        "0" = 0;

    
        /**
         * value: 1
         * @const
         */
        "1" = 1;

    
        /**
         * value: 2
         * @const
         */
        "2" = 2;

    
        /**
         * value: 3
         * @const
         */
        "3" = 3;

    

    /**
    * Returns a <code>DashboardControllerDtoGetDashboardDataDurationType</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/DashboardControllerDtoGetDashboardDataDurationType} The enum <code>DashboardControllerDtoGetDashboardDataDurationType</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

